// @flow
export const sortOptions = [
  {
    text: 'Newest to Oldest Updated',
    sort: {
      sortBy: 'updated',
      sortDirection: 'DESC'
    }
  },
  {
    text: 'Oldest to Newest Updated',
    sort: {
      sortBy: 'updated',
      sortDirection: 'ASC'
    }
  },
  {
    text: 'Newest to Oldest Created',
    sort: {
      sortBy: 'created',
      sortDirection: 'DESC'
    }
  },
  {
    text: 'Oldest to Newest Created',
    sort: {
      sortBy: 'created',
      sortDirection: 'ASC'
    }
  }
];

export const sorterValues = {
  searchSorterPlaceholder: 'Select',
  searchSorters: sortOptions[0],
};



// WEBPACK FOOTER //
// ./src/app/modules/global-whitelist/defaults.js